import React from 'react';
import { config } from '@app/config';
import { styled } from 'linaria/react';
import theme from 'clad-ui/theme/chotot';
import Image from 'next/image';
import LoadMore from './LoadMore/LoadMore';
const Wrapper = /*#__PURE__*/styled("div")({
  name: "Wrapper",
  class: "w1d827wb"
});
const Title = /*#__PURE__*/styled("h2")({
  name: "Title",
  class: "t16lncvr"
});
const Desc = /*#__PURE__*/styled("div")({
  name: "Desc",
  class: "d1mlmcxt"
});
const Item = /*#__PURE__*/styled("li")({
  name: "Item",
  class: "i19q506l"
});
const CategoryText = /*#__PURE__*/styled("span")({
  name: "CategoryText",
  class: "c1ix36js"
});
const CategorySubText = /*#__PURE__*/styled("span")({
  name: "CategorySubText",
  class: "clzh3k5"
});
const WrapperCat = /*#__PURE__*/styled("div")({
  name: "WrapperCat",
  class: "w1sxweed"
});
const Text = /*#__PURE__*/styled("div")({
  name: "Text",
  class: "t1ug96jk"
});
const ImgParent = /*#__PURE__*/styled("div")({
  name: "ImgParent",
  class: "i1hboxia"
});
const CategoryImg = /*#__PURE__*/styled("div")({
  name: "CategoryImg",
  class: "cemylwf"
});
const PartnerProgram = ({
  services = [],
  description = '',
  onClickSeeMore,
  onClickPartnerAd,
  isDone
}) => {
  const handleClickSeeMore = () => {
    if (onClickSeeMore) {
      onClickSeeMore();
      setTimeout(() => {
        window.location.href = `${config.jobURL}/kinh-nghiem/uu-dai-cho-doi-tac-tuyen-dung.html`;
      }, 500);
    }
  };
  const handleClickAd = text => {
    if (onClickPartnerAd) {
      onClickPartnerAd(text);
    }
  };
  return isDone && services.length > 0 ? <Wrapper>
      <Title>Trở thành Đối tác tuyển dụng</Title>
      <Desc dangerouslySetInnerHTML={{
      __html: description
    }} />
      <WrapperCat>
        {services.map((item, index) => {
        item.index = index;
        return <Item onClick={() => handleClickAd(item.text)} key={item.index}>
              <ImgParent>
                <CategoryImg>
                  <Image src={item.image} alt={item.text} width={68} height={68} loading="lazy" />
                </CategoryImg>
              </ImgParent>
              <Text>
                <CategoryText>{item.text || ''}</CategoryText>
                <CategorySubText>{item.sub_text || ''}</CategorySubText>
              </Text>
            </Item>;
      })}
      </WrapperCat>
      <LoadMore onClickSeeMore={handleClickSeeMore} />
    </Wrapper> : null;
};
export default PartnerProgram;

require("../../../.linaria-cache/src/components/PartnerProgram/index.linaria.module.css");